import { render, staticRenderFns } from "./AlertsWidgetComponent.vue?vue&type=template&id=2a138860&"
import script from "./AlertsWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./AlertsWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports